<div class="bz-env-component" *ngIf="!isBusy && metadata && tabs && environment">
  <bzg-tab-set class="bz-env-component-tabs" (onSelectTab)="selectedTab = $event.index">
    <bzg-tab-item *ngIf="tabs.Popular" [ngClass]="{'active-tab': selectedTab === 0}" displayName="{{'ENVIRONMENT.POPULAR' | translate | uppercase}}">
      <environment-popular #environmentPopularComponent [parameters]="environment.parameters" [SMTPSenderAcc]="SMTPSenderAcc"
        [metadata]="metadata.Properties" [sections]="tabs.Popular.Sections" [configurationEmail]="configurationEmail"
        [defaultSender]="defaultSender" [EnableWsSecurity]="EnableWsSecurity"></environment-popular>
    </bzg-tab-item>
    <bzg-tab-item *ngIf="tabs.Advanced" [ngClass]="{'active-tab': selectedTab === 1}" displayName="{{'ENVIRONMENT.ADVANCED' | translate | uppercase}}">
      <environment-advanced #environmentAdvancedComponent [parameters]="environment.parameters"
      [metadata]="metadata.Properties" [sections]="tabs.Advanced.Sections">
      </environment-advanced>
    </bzg-tab-item>
    <bzg-tab-item *ngIf="tabs.Custom" [ngClass]="{'active-tab': selectedTab === 2}" displayName="{{'ENVIRONMENT.CUSTOM' | translate | uppercase}}">
      <environment-custom></environment-custom>
    </bzg-tab-item>
  </bzg-tab-set>
</div>

<div class="bz-env-loading" *ngIf="isBusy || !tabs || !environment">
    <bz-loading [size]="'xl'" ></bz-loading>
</div>

<div class="bz-env-component__btn-save-container"  *ngIf="!isBusy && metadata && tabs && environment">
  <div class="bz-env-component__btn-save-warning">
    <bzg-icon [nameIcon]="'icon-warning'" [color]="'warning'" class="bz-space--inline-xs"></bzg-icon>
    {{ 'ENVIRONMENT.SAVE_ALL_MESSAGE' | translate }}
  </div>
  <bzg-button-primary class="bz-save-all" (click)="save()">{{'ENVIRONMENT.SAVE_ALL' | translate}}</bzg-button-primary>
</div>

<bz-info-dialog #infoDialog>
  <div class="bz-dialog-ivalid-fields">
    <div class="title">
      <i class="bz-icon bz-icon-abort-outline"></i>
      <h6>{{'ENVIRONMENT.SOMETHING_WENT_WRONG' | translate}}</h6>
    </div>
    <div class="content">
      <div *ngFor="let field of invalidFields">
        <i class="bz-icon bz-icon-right-outline"></i>
        <p>
          {{field.message | translate}}
          <strong *ngIf="field.control != ''"> {{'ENVIRONMENT.INTO_THE_FIELD' | translate}} {{field.control |
            translate}}</strong>
        </p>
      </div>
    </div>
    <a class="bz-go-back" href="javascript:;"
      (click)="infoDialog.hideDialog()">{{'ENVIRONMENT.GO_BACK' | translate}}</a>
  </div>
</bz-info-dialog>

<bz-button-fab (click)="save()" [type]="'save'" [tooltipText]="'GLOBAL.SAVE'"></bz-button-fab>

<bz-confirm-dialog #confirmDialog title="{{'GLOBAL.INFORMATION' | translate}}"
  message="{{'ENVIRONMENT.YOU_HAVE_PENDING_CHANGES' | translate}}">
</bz-confirm-dialog>
